
(function(){
  var nav=document.querySelector('[data-mf-nav]');
  if(!nav) return;
  var toggle=nav.querySelector('.mf-nav__toggle');
  var menu=nav.querySelector('#mf-mobile-menu');
  var close=nav.querySelector('.mf-mobile-menu__close');
  var dropdownButtons=nav.querySelectorAll('.mf-nav__chevron');
  var subtoggles=nav.querySelectorAll('.mf-mobile-subtoggle');

  function openMenu(){menu.hidden=false;document.documentElement.style.overflow='hidden';toggle.setAttribute('aria-expanded','true');}
  function closeMenu(){menu.hidden=true;document.documentElement.style.overflow='';toggle.setAttribute('aria-expanded','false');}
  if(toggle) toggle.addEventListener('click',openMenu);
  if(close) close.addEventListener('click',closeMenu);
  if(menu) menu.addEventListener('click',function(e){if(e.target===menu) closeMenu();});
  dropdownButtons.forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var li=btn.closest('.mf-has-dropdown');
      var isOpen=li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',isOpen?'true':'false');
    });
  });
  subtoggles.forEach(function(btn){
    btn.addEventListener('click',function(){
      var submenu=btn.parentElement.querySelector('.mf-mobile-submenu');
      var isOpen=submenu.classList.toggle('is-open');
      btn.textContent=isOpen?'−':'+';
      btn.setAttribute('aria-expanded',isOpen?'true':'false');
    });
  });
  window.addEventListener('scroll',function(){
    nav.classList.toggle('is-scrolled',window.scrollY>40);
  },{passive:true});
})();
